const getActionPlanStateColor = function getActionPlanStateColor(aps) {
  switch (aps) {
    case 1:
      return 'warning';
    case 2:
      return 'info';
    case 3:
      return '';
    default:
      return '';
  }
};
const getActionStateColor = function getActionStateColor(aps) {
  switch (aps) {
    case 1:
      return 'warning';
    case 2:
      return 'info';
    case 3:
      return 'info';
    case 4:
      return 'success';
    case 5:
      return '';
    case 6:
      return '';
    default:
      return '';
  }
};
const getPriorityColor = function getPriorityColor(aps) {
  switch (aps) {
    case 5:
      return 'success';
    case 4:
      return 'info';
    case 3:
      return 'warning';
    case 2:
      return 'accent';
    case 1:
      return 'red-mandy';
    default:
      return '';
  }
};

const formatField = function formatField(item, key, attributesObjRef) {
  if (typeof item[key] === 'boolean') {
    return item[key] ? 'Oui' : 'Non';
  }
  if (item[key] instanceof Date) {
    return item[key].toLocaleString();
  }

  if (attributesObjRef && key in attributesObjRef) {
    if (attributesObjRef[key].values.find((value) => value.id === item[key]))
      return attributesObjRef[key].values.find(
        (value) => value.id === item[key]
      ).name;
  }

  if (key.includes('.')) {
    const args = key.split('.');
    return item[args[0]] && item[args[0]][args[1]];
  }
  return item[key];
};

const formatItems = function formatItems(items, keys) {
  return items.map((item) => {
    const formatedItem = { ...item };
    keys.forEach((key) => {
      formatedItem[key] = formatField(item, key);
    });
    return formatedItem;
  });
};

const getEventColor = function getEventColor(originId) {
  switch (originId) {
    case 4: // 'STE'
      return 'warning';
    case 3: // 'P2C'
      return 'error';
    case 5: // 'Travaux'
      return 'success';
    case 7: // 'Action'
      return 'grey';
    default:
      return 'opposite';
  }
};
const getEventIcon = function getEventIcon(originId) {
  switch (originId) {
    case 4: // 'STE'
      return 'settings';
    case 3: // 'P2C'
      return 'contact_phone';
    case 5: // 'Travaux'
      return 'build';
    case 7: // 'Action'
      return 'input';
    default:
      return 'input';
  }
};

const getEntityIdFromNavFullId = (navFullId) =>
  navFullId && navFullId.substring(navFullId.length - 3);

function isObjEmpty(obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export {
  isObjEmpty,
  getActionPlanStateColor,
  getEntityIdFromNavFullId,
  getActionStateColor,
  formatField,
  formatItems,
  getPriorityColor,
  getEventColor,
  getEventIcon,
};
